import { Avatar } from "../../../components/Avatar";
import { Logo } from "../../../components/Logo";
import { Section } from "../DesignSystem";

const row: React.CSSProperties = {
  display: "flex",
  gap: "var(--space-4)",
  alignItems: "center",
  marginBottom: "var(--space-6)",
};

export const IdentitySection = () => (
  <Section label="10 · Components" title="Identity">
    <div style={row}>
      <Logo variant="full" />
      <Logo variant="mark" />
      <Logo variant="wordmark" />
    </div>
    <div style={row}>
      <Avatar name="Faria Azim" size="sm" />
      <Avatar name="Faria Azim" />
      <Avatar name="Faria Azim" size="lg" />
      <Avatar name="Rashed Haque" />
      <Avatar name="Nadia Karim" />
      <Avatar name="Allston Convenience" />
      <Avatar name="Central Square Market" />
    </div>
  </Section>
);
